module.exports = __webpack_public_path__ + "static/media/activityBg.d57a1255.webp";